var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.376.475c1.632 0 3.111.612 4.181 1.605 1.057.98 1.714 2.334 1.714 3.832.067 2.872-1.95 6.15-5.927 9.878C2.412 12.757.43 9.478.481 5.912c0-1.498.657-2.852 1.713-3.832C3.264 1.087 4.744.475 6.376.475z",
    stroke: "#848383",
    strokeWidth: 0.96,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.364 4.48C7.582 4.48 8.8 5.521 8.8 6.805 8.8 8.09 7.71 9.13 6.364 9.13c-1.346 0-2.437-1.04-2.437-2.325 0-1.284 1.218-2.325 2.437-2.325z",
    fill: "#848383"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsLocation);
export default __webpack_public_path__ + "static/media/details-location.c296257f3b04f76621c07da942eb2eaf.svg";
export { ForwardRef as ReactComponent };